import React, { Component } from "react"
import ReactDOM from 'react-dom';

export class DynamicMembershipForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedOption: 'Select Organization'
    }
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleIdChange = this.handleIdChange.bind(this);
  }

 handleIdChange(e) {
    this.props.onIdChange(e.target.value, this.props.keyId);
  }

 handleNameChange(e) {
  this.setState({selectedOption: e.target.value})
    this.props.onNameChange(e.target.value, this.props.keyId);
  }

  render() {
    return (
        <div key={this.props.keyId}>
          <div className="control-group select optional user_equine_associations_name">
            <label className="select optional control-label">{this.props.fieldNames[0]}</label>
            <div className="controls">
              <select className="select optional" id="organization" onChange={this.handleNameChange}>
                {this.props.organizationList}
              </select>
            </div>
          </div>
          <div className="control-group string optional user_equine_associations_number">
            <label className="string optional control-label">{this.props.fieldNames[1]}</label>
            <div className="controls">
              <input className="string optional" type="text" onChange={this.handleIdChange}/>
            </div>
          </div>
        </div>
    );
  }
}
